import CloseIcon from "@mui/icons-material/CloseRounded";
import { Container, Dialog, IconButton, Typography } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { useBreakpointQuery } from "hooks/useBreakPointQuery";
import { useDispatch, useSelector } from "react-redux";
import { MenuLink } from "./MenuLink";
import { closeMenu, selectIsMenuOpen } from "./navigationSlice";
import { MenuLinkInfo, useNavigationLinks } from "./useNavigationLinks";

const useStyles = makeStyles((theme) => ({
    menuItemList: {
        listStyleType: "none",
        paddingInlineStart: 0,
        marginTop: theme.spacing(4),
    },
    menuContainer: {
        padding: theme.spacing(2, 6),
        paddingBottom: theme.spacing(6),
    },

    closeIcon: {
        position: "fixed",
        top: theme.spacing(2),
        right: theme.spacing(4),
        zIndex: 1,
    },
}));

export const FullPageMenu = (props: any) => {
    const dispatch = useDispatch();
    const classes = useStyles();

    const menuIsOpen = useSelector(selectIsMenuOpen);
    const hamburgerMenuVisible = useBreakpointQuery("lg");

    const links = useNavigationLinks(true);

    const renderLink = (link: MenuLinkInfo, index: number) => {
        return (
            <li key={link.name}>
                <Typography variant="h2">
                    <MenuLink
                        link={link}
                        isFullPageMenu={true}
                        onClick={() => dispatch(closeMenu())}
                        onClickSubNav={() => dispatch(closeMenu())}
                    />
                </Typography>
            </li>
        );
    };

    return (
        <Dialog
            fullScreen
            open={hamburgerMenuVisible && menuIsOpen}
            onClose={() => dispatch(closeMenu())}
        >
            <Container maxWidth="lg" className={classes.menuContainer}>
                <IconButton
                    className={classes.closeIcon}
                    aria-label="close"
                    color="secondary"
                    onClick={() => dispatch(closeMenu())}
                    data-testid="closeMobileMenu"
                    size="medium"
                >
                    <CloseIcon />
                </IconButton>
                <ul className={classes.menuItemList}>{links.map(renderLink)}</ul>
            </Container>
        </Dialog>
    );
};
